function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M108.793 91.0087L161.41 70.5368C168.828 67.651 176.951 69.6388 182.38 74.9444C183.259 74.6727 184.11 74.3884 184.977 74.1447C189.14 72.8993 198.255 71.9039 200.39 77.3915C201.157 79.363 200.247 83.0867 199.163 84.6551C197.828 86.5786 195.727 88.1217 193.587 89.3289C192.819 89.768 192.035 90.1665 191.275 90.5089C190.635 90.8049 188.793 91.5447 186.137 92.6018L134.017 112.88L96.5068 112.568L108.793 91.0087Z",
  fill: "#766B44"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M137.918 96.9622L137.935 96.8871L121.518 103.275L108.484 108.346L108.749 91.3027L107.288 24.8906L85.6658 100.284L53.4551 114.19L19.4979 103.526C16.7509 102.649 14.6523 106.029 16.6341 108.119L30.7422 123.004L50.7016 144.86L108.45 122.392L109.813 190.673L133.232 112.772L133.272 112.757L137.938 96.9545L137.918 96.9622V96.9622Z",
  fill: "#C2B45E"
});

function SvgVoltaAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 212,
    viewBox: "0 0 227 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltaAppIcon);
export default __webpack_public_path__ + "static/media/volta-app-icon.5f1c3d4a.svg";
export { ForwardRef as ReactComponent };